export function isMailtoURL(url: string) {
  return /^mailto:/i.test(url);
}
